"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/AutoReplyMessage.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _time = require('shared/services/time');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _TextMessage = require('./TextMessage');








// An auto-reply mentions nobody, so no viewer matches a mention.
const NO_VIEWER = '' 

/* A team's automatic reply to a patient, texted or posted in a secure chat:
 * an outgoing bubble labelled "⚡ Auto-reply · 9:14 AM". It has no sender to
 * act as, so it carries no actions or reactions. */
const AutoReplyMessage = ({ messageKey, text, sentAt, highlighted }) => (
  _react2.default.createElement('div', {
    className: _classBuilder2.default.call(void 0, 
      'rich-message rich-message--me rich-message--run-first rich-message--run-last auto-reply',
      { highlighted },
    ),
    id: messageKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}

    , _react2.default.createElement('div', { className: "rich-message--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
      , _react2.default.createElement('div', { className: "rich-message--message", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
        , _react2.default.createElement('div', { className: "rich-message--message--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
          , _react2.default.createElement('span', { className: "rich-message--message--name--sender auto-reply--label" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
            , _react2.default.createElement('svg', {
              className: "auto-reply--icon",
              width: 12,
              height: 12,
              viewBox: "0 0 24 24"   ,
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              'aria-hidden': "true",
              focusable: "false", __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}

              , _react2.default.createElement('path', { d: "M13 2L3 14h9l-1 8 10-12h-9l1-8z"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}} )
            ), "Auto-reply"

          )
          ,  sentAt && (
            _react2.default.createElement('span', { className: "rich-message--message--name--timestamp", title: _time.formatLongDisplayDate.call(void 0, sentAt), __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
              ,  _time.getDayTimeString.call(void 0, sentAt) 
            )
          )
        )
        , _react2.default.createElement('div', { className: "rich-message--message-container", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
          , _react2.default.createElement('div', { className: "rich-message--message-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
            , _react2.default.createElement('div', { className: "text-message text-message--me" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
              , _react2.default.createElement(_TextMessage.MessageBody, { text: text, currentUserKey: NO_VIEWER, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}} )
            )
          )
        )
      )
    )
  )
)

exports. default = _react.memo.call(void 0, AutoReplyMessage)
